export default [
    {
        name: 'packs.mine',
        path: '/packs/me',
        component: () => import("@/views/modules/packing/pages/my-packs/List.vue")
    },
    {
        name: 'packs.all',
        path: '/packs',
        component: () => import("@/views/modules/packing/pages/all-packs/List.vue")
    },
    {
        name: 'packs.pack',
        path: '/packs/:id/lines',
        component: () => import("@/views/modules/packing/pages/pack/ListItems.vue")
    }
]
